module.exports = __webpack_public_path__ + "img/info-circle.ae51fdc2.svg";